export default {
  props: ['infoObj']
};